// extracted by mini-css-extract-plugin
module.exports = {"limitedText":"ReadFullNote_limitedText__1waL6","overflowing":"ReadFullNote_overflowing__21WHN"};